export default __webpack_public_path__ + "static/media/inp.ae0bfdd0.jpg";